import OTPModal from "../common/OTPModal";
import LoginForm from "./LoginForm";
import Selfservice from "./selfservice";
import Newpassword from "./newpassword";
import Success from "./sucess";
import RecoverPassword from "./RecoverPassword"
import React, {useContext, useState} from "react";
import { useNavigate } from "react-router-dom";



function Login() {
  const [userName, setUsername] = useState();
  const [modalVisible, setModalVisible] = useState(true)
  const [page, setPage] = useState("login")
  const [successVisible, setSuccessVisible] = useState(false);
  const [validationDetails, setValidationDetails] = useState({})
  const [userCredentials, setUserCredentials] = useState({})
  const [message, setMessage] = useState("Your new password has been set successfully")
  const [usrprop, serUserNameProp] = useState();
  const navigate = useNavigate()
  const goToHome = () => {
    navigate("/")
  }

  const goToLogin = () => {
    if (Object.keys(userCredentials).length > 0) {
      navigate("/")
      return
        }
      setPage("login")
      setSuccessVisible(false)
  }


  return (
    <div className="login-container">
      {modalVisible && <OTPModal userCredentials={userCredentials} setValidationDetails={setValidationDetails} validationDetails={validationDetails} userName={userName} modalVisible={modalVisible} setModalVisible={setModalVisible} action={goToHome} setPage={setPage} />}
      {page === "login" && <LoginForm setUserCredentials={setUserCredentials} setValidationDetails={setValidationDetails} userName={userName} setUsername={setUsername} modalVisible={modalVisible} setModalVisible={setModalVisible} setPage={setPage} />}
      {page === "self" && <Selfservice setMessage={setMessage} setPage={setPage} setSuccessVisible={setSuccessVisible} serUserNameProp={serUserNameProp} />}
      {page === "password" && <Newpassword  userName={userName} setPage={setPage} setSuccessVisible={setSuccessVisible}  setUserCredentials={setUserCredentials} setValidationDetails={setValidationDetails} />}
      {page === "recover" && <RecoverPassword isVerified={true} setPage={setPage} setSuccessVisible={setSuccessVisible} setUserCredentials={setUserCredentials}  userName={usrprop} />}

      {successVisible && <Success message={message} userCredentials={userCredentials} action={goToLogin} />}

    </div>
  );
}

export default Login;
